import { productsImages } from "../data/products_images";
import { Product_2 } from "../types/types_product_2";
import { Product } from "../types/types_product";
import { profileData, linksData } from "../data/data";

export function getTitleName(path: string): string {
   if (path && path === "/") return `${profileData.name} - ${linksData[0].name}`;

   const cleanedPath = path.startsWith('/') ? path.slice(1) : path;
   const formattedPath = cleanedPath.charAt(0).toUpperCase() + cleanedPath.slice(1);

   return `Socks Store - ${formattedPath}`;
}


/**
 * Sorts an array of products, where the array can contain both `Product` and `Product_2` items.
 * 
 * If the array contains `Product_2` items, the sorting is done first by the `newItem` property (priority given to items marked as "Новинка" or "New Product"), 
 * and then by the `id` property of `Product_2`.
 * 
 * If the array contains only `Product` items, the sorting is done by the `product_id` property.
 * 
 * @param data - An array of `Product` or `Product_2` items to be sorted.
 * @param isProduct_2 - A type guard function that helps identify whether an item is of type `Product_2`.
 * @returns A new array with the items sorted according to the logic described above.
 */
export function sortProductsData(
   data: (Product | Product_2)[],
   isProduct_2: (item: Product | Product_2) => item is Product_2
): (Product | Product_2)[] {
   let result: (Product | Product_2)[];

   if (data.some(isProduct_2)) {
      result = [...data].sort((a, b) => {
         const aItem = a as Product_2;
         const bItem = b as Product_2;

         if (aItem.newItem === "Новинка" && bItem.newItem !== "Новинка") return -1;
         if (aItem.newItem !== "Новинка" && bItem.newItem === "Новинка") return 1;

         return bItem.id - aItem.id;
      });
   } else {

      result = [...data].sort((a, b) => {
         const aItem = a as Product;
         const bItem = b as Product;

         return bItem.product_id - aItem.product_id;
      });
   }

   return result;
}

/**
 * Adds images to a list of `Product_2` items by mapping each product to its corresponding image.
 * 
 * For each product, the function tries to find an image using the product's `sku` property. 
 * If an image corresponding to the `sku` is found in the `productsImages` object, it is assigned to the product.
 * If no image is found for that `sku`, a default image (`img_2883603702`) is assigned.
 * 
 * @param products - An array of `Product_2` items that need to be updated with images.
 * @returns A new array of `Product_2` items where each item has the `images` property added or updated.
 */
export function addImagesToProducts(products: Product_2[]): Product_2[] {
   return products.map((product) => {
      const key = `img_${product.sku}` as keyof typeof productsImages;
      const key2 = `img_2883603702` as keyof typeof productsImages;
      const imagesForProduct = productsImages[key];

      return {
         ...product,
         images: imagesForProduct ?? productsImages[key2],
      };
   });
}

export function findPromoItem(searchArr: (Product | Product_2)[], searchTerm: string) {
   return searchArr.find(promo => promo.name.toLowerCase().includes(searchTerm.toLowerCase()));
};